export var getMuiListItemOverrides = function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            borderLeft: 'solid 3px transparent',
            backgroundColor: 'transparent',
            '&:hover': {
                backgroundColor: 'transparent',
            },
            '&$selected': {
                backgroundColor: 'transparent',
                borderLeftColor: palette.primary.main,
                '&:hover': {
                    backgroundColor: 'transparent',
                },
            },
            '&$button:hover': {
                backgroundColor: 'transparent',
                color: palette.primary.main,
            },
        },
    });
};
//# sourceMappingURL=MuiListItem.js.map